import React from "react";
import { connect } from "react-redux";
import type { RootState } from "redux/reducers";
import toggleUtils from "shared/toggleUtils";
import userUtils from "shared/userUtils";
import { ConfigurationItemsVisibility } from "../configurations.types";
import ConfigurationTabs from "./configurationTabs";
import { updateSelectedConfigurationTab } from "redux/operations";

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
type ConfigurationTabsContainerProps = StateProps & DispatchProps;

export const ConfigurationTabsContainer = ({
  selectedTab,
  selectedFarmId,
  toggles,
  onSelectTab,
}: ConfigurationTabsContainerProps) => {
  const configurationVisibility: ConfigurationItemsVisibility = {
    showCauseOfDeath: toggleUtils.isCauseOfDeathRegistrationActive(toggles),
    showFormulationRegistration:
      toggleUtils.isFormulationRegistrationActive(toggles),
    showHerdEvolutionAndNutritionPlan: userUtils.isInternalUser(),
    showLotGoal: toggleUtils.isLotGoalRegistrationActive(toggles),
    showRainHistory: toggleUtils.isRainActive(toggles),
    showScoreAdjustment: toggleUtils.isScoreAdjustmentActive(toggles),
    showWeightGain: toggleUtils.isWeightGainRegistrationActive(toggles),
  };

  return (
    <ConfigurationTabs
      hasSelectedFarm={selectedFarmId != null}
      itemsVisibility={configurationVisibility}
      onTabChange={onSelectTab}
      selectedTab={selectedTab}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  selectedTab: state.configurations.selectedTab,
  selectedFarmId: state.fazenda.FazendaSelecionada,
  toggles: state.fazenda.Toggles,
});

const mapDispatchToProps = {
  onSelectTab: updateSelectedConfigurationTab,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfigurationTabsContainer);
